export function round2(value: number) {
    const round = Math.round(value * 100);
    const result = round / 100;
    //console.log(`value=${value};round=${round};result=${result}`);
    return result;
}

export function round2string(value: number) {
    return round2(value).toFixed(2);
}